import {
  RtSystemQuantityScopeDto,
  RtSystemScopeDto,
  RtSystemQuantityScopeDtoTypeEnum,
} from '@/api/generator';
import { pick } from 'lodash';
import { reactive } from 'vue';
import { api } from '@/api';

/**
 * helper for below - convertes RtSystemScopeDto obj to RtSystemQuantityScopeDto
 * @param scope
 * @returns
 */
function toQuantityScope(scope: RtSystemScopeDto): RtSystemQuantityScopeDto {
  return {
    ...pick(scope, ['id', 'rtSystemCategory', 'rtSystemSubCategory']),
    $type:
      RtSystemQuantityScopeDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoRtSystemQuantityScopeDtoPtwPtw100AppZeroApplicationShared,
  };
}

export function useScopeOptions() {
  const options = reactive<{
    qaEquipment: RtSystemQuantityScopeDto[];
    medicalSystems: RtSystemQuantityScopeDto[];
  }>({
    qaEquipment: [],
    medicalSystems: [],
  });

  async function load() {
    const { result: qaEquipmentScopes } = await api.taskItemsApi.getQaEquipmentTypesScope();

    options.qaEquipment = (qaEquipmentScopes?.systemScopes || []).map(toQuantityScope);

    const { result: medicalSystemScopes } = await api.taskItemsApi.getMedicalSystemTypesScopes({
      renameNone: true,
    });

    options.medicalSystems = (medicalSystemScopes?.systemScopes || []).map(toQuantityScope);
  }

  return {
    load,
    options,
  };
}
